import salesforceCrmReadmeMarkdown from '@/assets/Artifacts/README.md?raw'
import { buildAppPublicUrl } from '@/config/env/appOrigin.js'
import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'
import { NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME } from './nexusIntegrationsDemo.js'
import { buildFileWriteNarration, buildStepNarration } from './stepNarrationCopy.js'
import { CRM_PROJECT_ROOT } from './zohoCrmIntegrationDemoContent.part01.js'

export const ZOHO_CRM_INTEGRATION_AI_LOG_STEPS_INITIAL = [
  {
    durationMs: 199000,
    actionName: 'Finished running command',
    arguments: {
      command: `mkdir -p ${CRM_PROJECT_ROOT}/{app/{api,core,services,schemas,models},tests,docs}`,
    },
    result: { log: '', exitCode: 0 },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'The salesforce-integration/ folder structure is scaffolded',
      'writing core config and the Salesforce OAuth client',
      0,
    ),
  },
]
